import React, { useState } from "react";
import { Row, Spin } from "antd";
import { getStyles } from "./Style";
import { AdminHeader } from "./AdminHeader";
import { QuickStats } from "./QuickStats";
import { TrainingSection } from "./TrainingSection";
import { PendingRequests } from "./PendingRequests";
import { QuickActions } from "./QuickActions";
import { LoadingOutlined } from "@ant-design/icons";
import useAdminDashboard from "PlatForms/OrgLMS/Hooks/AdminHooks/useAdminDashboard";
import { TrainingLibrary } from "./TrainingLibrary";

const AdminLandingPage = () => {
  const [darkMode, setDarkMode] = useState(false);
  const { dashboardData, loading, error } = useAdminDashboard();
  const spinnerIcon = <LoadingOutlined style={{ fontSize: 48, color: "#9A6B0E" }} spin />;

  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "80vh", // Full screen height
          backgroundColor: darkMode ? "#141414" : "#fff",
          transition: "background-color 0.3s ease", // Smooth background transition
        }}
      >
        <div style={{ textAlign: "center" }}>
          <Spin
            indicator={spinnerIcon}
            tip="Loading your dashboard, please wait..."
            size="large"
            style={{
              display: "inline-block",
              marginBottom: 16,
            }}
          />
          <div
            style={{
              fontSize: "18px",
              color: darkMode ? "#fff" : "#000",
              fontWeight: 600,
              marginTop: "20px",
            }}
          >
            Please wait while we load your data.
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "center",
          alignItems: "center",
          height: "80vh",
          backgroundColor: darkMode ? "#141414" : "#fff",
          color: darkMode ? "#fff" : "#000",
          fontSize: 18,
          fontWeight: 500,
        }}
      >
        ⚠️ Error: {error}
      </div>
    );
  }

  if (!dashboardData) {
    return <div>No data available</div>;
  }

  const toggleDarkMode = () => setDarkMode(!darkMode);
  const styles = getStyles(darkMode);

  return (
    <div style={styles.container}>
      <AdminHeader
        darkMode={darkMode}
        toggleDarkMode={toggleDarkMode}
      />

      <QuickStats stats={dashboardData} darkMode={darkMode} />

      <Row gutter={[24, 24]}>
        <TrainingSection activeTrainings={dashboardData.trainings} darkMode={darkMode} />
        <PendingRequests pendingRequests={dashboardData.trainingRequests} darkMode={darkMode} />
      </Row>
      <br />
      <Row gutter={[24, 24]}>
        <QuickActions darkMode={darkMode} />
        <TrainingLibrary courseLibraryStats={dashboardData.library} darkMode={darkMode} />
      </Row>
    </div>
  );
};

export default AdminLandingPage;
